import React, { useMemo } from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import DateFilterComponent from '@ui/components/Date-filter/Date-filter.component';
import SelectComponent from '@ui/components/Select/Select.component';
import useDictionary from '@ui/hooks/useDictionary';
import { IProps } from './IProps';
import { variants } from '@ui/components/Select/variants.enum';

const Component: React.FC<IProps> = ({
    lang,
    report,
    reports,
    devices,
    selectedDevice,
    dateFilter,
    fromDateFilterCurrent,
    toDateFilterCurrent,
    groups,
    timezone,
    selectedGroup,
    onReportChange,
    onReportClick,
    onDeviceChange,
    onFromDateChange,
    onToDateChange,
    onDateFilterChange,
    onGroupChange,
}: IProps) => {
    const getWord = useDictionary();
    const devicesList = useMemo(
        () => devices.map(({ imei: value, name: label }) => ({ value, label })),
        [devices],
    );
    const groupsList = useMemo(() => {
        const allGroups = { id: 'allGroups', name: 'allGroups' };
        return [allGroups, ...groups].map(({ id: value, name: label }) => ({
            value,
            label,
        }));
    }, [groups]);
    const dateFiltersList = [
        'last24Hours',
        'last3Days',
        'lastWeek',
        'customDate',
    ];

    const getDateFilter = () => {
        let dateFilterComponent: React.ReactElement;
        if (dateFilter === 'customDate') {
            dateFilterComponent = (
                <DateFilterComponent
                    lang={lang}
                    timezone={timezone}
                    fromDateFilter={fromDateFilterCurrent}
                    toDateFilter={toDateFilterCurrent}
                    onFromDateChange={onFromDateChange}
                    onToDateChange={onToDateChange}
                />
            );
        } else dateFilterComponent = <></>;
        return (
            <>
                <SelectComponent
                    lang={lang}
                    name="date-filter"
                    value={dateFilter}
                    values={dateFiltersList}
                    onChange={onDateFilterChange}
                />
                {dateFilterComponent}
            </>
        );
    };
    const dateFilters = getDateFilter();

    return (
        <Box className="reports__menu" component="section">
            <FormControl className="reports__menu__form" component="form">
                <SelectComponent
                    label="report"
                    name="report"
                    lang={lang}
                    value={report}
                    values={reports}
                    variant={variants.sidebar}
                    onChange={onReportChange}
                />
                {report === 'telemetry' && (
                    <>
                        <SelectComponent
                            label="device"
                            name="device"
                            lang={lang}
                            value={selectedDevice}
                            values={devicesList}
                            variant={variants.sidebar}
                            onChange={onDeviceChange}
                        />
                        {dateFilters}
                    </>
                )}
                {report === 'currentState' && (
                    <>
                        <SelectComponent
                            label="group"
                            name="group"
                            lang={lang}
                            value={selectedGroup}
                            values={groupsList}
                            variant={variants.sidebar}
                            onChange={onGroupChange}
                        />
                    </>
                )}
            </FormControl>
            <Box className="reports__menu-btn-bar">
                <Button
                    className="reports__menu-btn"
                    variant="contained"
                    onClick={onReportClick}
                >
                    {getWord('generateReport')}
                </Button>
            </Box>
        </Box>
    );
};

const ReportsMenuComponent = React.memo(Component);

export default ReportsMenuComponent;
